import { render, staticRenderFns } from "./PaymentsAndCurrenciesCurrenciesAndTokens.vue?vue&type=template&id=10d36310&"
import script from "./PaymentsAndCurrenciesCurrenciesAndTokens.vue?vue&type=script&lang=js&"
export * from "./PaymentsAndCurrenciesCurrenciesAndTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports